<template>
    <div class="billing_view">
        <loading v-if="loading"/>
        <!-- 停車帳務_view -->
            <section class="chapternav-top">
              <div class="container">
                <div class="row">
                  <div class="col-lg-12 text-center">
                    <h2 class="section-heading text-uppercase">Billing</h2>
                    <h3 class="section-subheading text-muted">停車帳務</h3>
                  </div>
                </div>

                <div class="blank-box" v-if="!billing.id && !loading">
                  <i class="fas fa-7x fa-grin-beam-sweat"></i><br>
                  您目前尚無任何停車紀錄
                </div>

                <div class="row">
                  <div class="col-lg-6 billing-view-box row" v-if="billing.id">

                    <div class="col-lg-12 billing-card">
                        <div class="billing-current-title" v-if="billing.reservation">預約停車</div>
                        <div class="billing-top-box">
                            <div class="billing-time-box">
                                <div class="billing-time" v-if="!billing.reservation">
                                  {{ billing.counted_at | DateToDay }} <br/>
                                  <span>{{ billing.counted_at | DateToTime }}</span>
                                </div>
                                <div class="billing-time" v-if="billing.reservation">
                                  {{ billing.reservation.reservation_date }}  <br/>
                                  <span>00:00</span>
                                </div>
                                <div class="billing-arrow">
                                  >
                                </div>
                                <div class="billing-time" v-if="!billing.reservation">
                                 {{ billing.paid_at | DateToDay }}  <br/>
                                  <span> {{ billing.paid_at | DateToTime }}</span>
                                </div>
                                <div class="billing-time" v-if="billing.reservation">
                                 {{ billing.reservation.reservation_date }}  <br/>
                                  <span>23:59</span>
                                </div>
                                <div style="clear: both;"></div>
                            </div>
                            <div class="billing-price-box" v-if="billing.payment_records[0]">
                                <div class="billing-price-title">實付金額</div>
                                <div class="billing-price-number">{{ billing.payment_records[0].actual_fee }}</div>
                                <div style="clear: both;"></div>
                                <div class="billing-price-title">應付金額</div>
                                <div class="billing-price-number2">{{ billing.payment_records[0].origin_fee }}</div>
                            </div>
                            <div style="clear: both;"></div>
                        </div><!--billing-top-box ends-->
                        <div class="billing-place-box">
                          <div class="billing-plate">{{ billing.plate }}</div>
                          <router-link :to="'parkinglot_view?id=' + billing.lot.id" v-if="billing.lot" class="billing-place">{{ billing.lot.name }}</router-link>
                          <div style="clear: both;"></div>
                        </div>
                    </div><!--billing-card ends-->
                    
                  </div><!--billing-view-box ends-->
                  
                </div><!--row ends-->

                
                <div class="row" v-if="billing.id && billing.payment_records[0]">
                  <div class="billing-detail-box" >
                    <div class="billing-detail-title fl">
                      統一發票
                    </div><!--billing-detail-title ends-->
                    <div class="billing-detail-content fr">
                      {{ billing.payment_records[0].invoice_number }}
                    </div><!--billing-detail-content ends-->
                    <div class="cb"></div>
                    <div class="billing-detail-title fl" v-if="billing.payment_records[0].random_code">
                      隨機碼
                    </div><!--billing-detail-title ends-->
                    <div class="billing-detail-content fr" v-if="billing.payment_records[0].random_code">
                      {{ billing.payment_records[0].random_code }}
                    </div><!--billing-detail-content ends-->
                    <div class="cb"></div>
                    <div class="billing-detail-title fl" v-if="billing.payment_records[0].identification_code">
                      識別碼
                    </div><!--billing-detail-title ends-->
                    <div class="billing-detail-content fr" v-if="billing.payment_records[0].identification_code">
                      {{ billing.payment_records[0].identification_code }}
                    </div><!--billing-detail-content ends-->
                    <div class="cb"></div>
                     <div class="billing-detail-title fl" v-if="billing.payment_records[0].invoice_number">
                      電子發票證明聯
                    </div><!--billing-detail-title ends-->
                    <div class="billing-detail-content fr" v-if="billing.payment_records[0].receipt_uuid">
                      <a :href="'https://parkmang.liteon.com/display_receipt/'+ billing.payment_records[0].receipt_uuid">https://parkmang.liteon.com/display_receipt/{{ billing.payment_records[0].receipt_uuid }}</a>
                    </div><!--billing-detail-content ends-->
                    <div class="billing-detail-content fr" v-if="!billing.payment_records[0].receipt_uuid">
                      尚未上傳請稍後再試
                    </div><!--billing-detail-content ends-->
                    <div class="cb"></div>
                  </div><!--billing-detail-box ends-->

                  <div class="billing-detail-box" v-if="billing.payment_records[0].invoice_type == 1">
                    <div class="billing-detail-title fl">
                      捐贈發票
                    </div><!--billing-detail-title ends-->
                      <div class="cb"></div>
                      <div class="billing-detail-title fl">
                        愛心碼
                      </div><!--billing-detail-title ends-->
                      <div class="billing-detail-content-black fr">
                        {{ billing.payment_records[0].invoice_code }}
                      </div><!--billing-detail-content-black ends-->
                      <div class="cb"></div>
                  </div><!--billing-detail-box ends-->

                  <div class="billing-detail-box" v-if="billing.payment_records[0].invoice_type == 2">
                    <div class="billing-detail-title fl">
                      開立統一編號
                    </div><!--billing-detail-title ends-->
                      <div class="cb"></div>
                      <div class="billing-detail-title fl">
                        統一編號
                      </div><!--billing-detail-title ends-->
                      <div class="billing-detail-content-black fr">
                        {{ billing.payment_records[0].tax_code }}
                      </div><!--billing-detail-content-black ends-->
                      <div class="cb"></div>
                      <div class="billing-detail-title fl">
                        電子信箱
                      </div><!--billing-detail-title ends-->
                      <div class="billing-detail-content-black fr">
                        {{ billing.payment_records[0].tax_email }}
                      </div><!--billing-detail-content-black ends-->
                      <div class="cb"></div>
                      <div class="billing-detail-title fl" v-if="billing.payment_records[0].tax_company">
                        公司抬頭
                      </div><!--billing-detail-title ends-->
                      <div class="billing-detail-content-black fr" v-if="billing.payment_records[0].tax_company">
                        {{ billing.payment_records[0].tax_company }}
                      </div><!--billing-detail-content-black ends-->
                      <div class="cb" v-if="billing.payment_records[0].tax_company"></div>
                  </div><!--billing-detail-box ends-->

                  <div class="billing-detail-box" v-if="billing.payment_records[0].invoice_type == 3">
                    <div class="billing-detail-title fl">
                      手機條碼載具
                    </div><!--billing-detail-title ends-->
                      <div class="cb"></div>
                      <div class="billing-detail-title fl">
                        手機條碼
                      </div><!--billing-detail-title ends-->
                      <div class="billing-detail-content-black fr">
                        {{ billing.payment_records[0].cell_phone_invoicing_code }}
                      </div><!--billing-detail-content-black ends-->
                      <div class="cb"></div>
                  </div><!--billing-detail-box ends-->

                  <div class="billing-detail-box" v-if="billing.payment_records[0].invoice_type == 4">
                    <div class="billing-detail-title fl">
                      自然人憑證載具
                    </div><!--billing-detail-title ends-->
                      <div class="cb"></div>
                      <div class="billing-detail-title fl">
                        自然人憑證
                      </div><!--billing-detail-title ends-->
                      <div class="billing-detail-content-black fr">
                        {{ billing.payment_records[0].natural_person_code }}
                      </div><!--billing-detail-content-black ends-->
                      <div class="cb"></div>
                  </div><!--billing-detail-box ends-->

                  <div class="col-lg-8 center">
                      <div class="btn-services fl">
                        <!--
                        <a class="btn btn-frame js-scroll-trigger" href="#">聯絡客服</a>
                        !-->
                      </div>
                      <div class="btn-back fr">
                        <button class="btn btn-primary js-scroll-trigger" @click="$router.go(-1)"><i class="fas fa-chevron-left"></i> BACK</button>
                      </div>
                      <div class="cb"></div>
                  </div>
                </div><!--row ends-->


                  
              </div><!--container ends-->
            </section>

    </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'BillingView',
  props: {
  },
  data() {
    return {
      billing: {},
      loading: true
    }
  },
  filters: {
    DateToDay(value) {
      return moment(String(value)).format('YYYY.MM.DD')
    },
    DateToTime(value) {
      return moment(String(value)).format('HH:mm')
    }
  },
  mounted() {
    var self = this
    self.getbillingDetails()
  },
  methods: {
    getbillingDetails: function() {
      var self = this
      if (parseInt(self.$route.query.id) > 0) {
        self.$http.get('https://' + process.env.VUE_APP_API_URL + '/parking_records/details?access_token=' + self.$cookie.get('access_token') + '&id=' + self.$route.query.id)
          .then(response => response.json())
          .then(json => {
            self.billing = json
            self.loading = false
          })
          .catch((response) => {
            console.log("取得資料失敗")
            self.$router.push({ name: 'member_center' })
          })
          .finally(() => {
          });
      } else {
        self.loading = false
      }
    }
  }
}
</script>